import React from 'react';

import { ReferentielUsesDto } from 'lib_api/lib/api/gen';

import { buildUsesInDossierMessage } from '../../Modals/ModalDesactivation/utils';

interface UsesGenreSimplifieProps {
  uses: ReferentielUsesDto;
}

function UsesGenreSimplifie({
  uses,
}: UsesGenreSimplifieProps): React.ReactElement {
  const listDossierId = uses.searchDossierResult?.listDossierId ?? [];
  return (
    <ul>
      {listDossierId.length > 0 && (
        <li>
          Ce genre simplifié est utilisé dans les dossiers{' '}
          {buildUsesInDossierMessage(uses.searchDossierResult)}
        </li>
      )}
    </ul>
  );
}

export default UsesGenreSimplifie;
